export const ENV = {
  baseUrl: import.meta.env.VITE_API_BASE_URL,
  VITE_API_KEY_GOOGLE_MAPS: import.meta.env.VITE_API_KEY_GOOGLE_MAPS,
  VITE_GOOGLE_CLIENT_ID: import.meta.env.VITE_GOOGLE_CLIENT_ID,
  NOTIFICATION_PUBLIC_KEY: import.meta.env.VITE_NOTIFICATION_PUBLIC_KEY,
  VITE_APP_VAPID_KEY: import.meta.env.VITE_APP_VAPID_KEY,
  VITE_GIT_HASH: import.meta.env.VITE_GIT_HASH,
  baseUrlV2: import.meta.env.VITE_API_BASE_URL_V2,
  sentryDsn: import.meta.env.VITE_SENTRY_DSN,
  VITE_API_KEY_GOOGLE_MAPS_NEW: import.meta.env.VITE_API_KEY_GOOGLE_MAPS_NEW,
  VITE_FIREBASE_CONFIG: import.meta.env.VITE_FIREBASE_CONFIG,
  VITE_FIREBASE_DATABASE: import.meta.env.VITE_FIREBASE_DATABASE,
  bookingWebsiteV2Enabled:
    import.meta.env.VITE_BOOKING_WEBSITE_V2_ENABLED === 'true',
  bookingPreviewUrl:
    import.meta.env.VITE_BOOKING_PREVIEW_URL ||
    'https://demo.glossify.id/preview',
}
